import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import FileInput from "@/Components/FileInput";
import LoadingButton from "@/Components/LoadingButton";
import Label from "@/Components/Label";
import PageHeading from "@/Components/PageHeading";
import MultiSelectInput from "@/Components/MultiSelectInput";
import { Inertia } from "@inertiajs/inertia";

const Import = () => {
    const { groups } = usePage().props;

    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Student", route: route("students") },
        { name: "Import", route: null },
    ];

    const { data, setData, errors, post, processing, transform } = useForm({
        importFile: null,
        groups: [],
    });

    transform((data) => ({
        ...data,
        groups: _.map(data.groups, "id"),
    }));

    function handleSubmit(e) {
        e.preventDefault();
        post(route("students.import"));
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("students"));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Import Students"} breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label
                                    label={"Upload File"}
                                    name={"importFile"}
                                />
                                <FileInput
                                    label={"Import File"}
                                    name={"importFile"}
                                    accept={".xlsx"}
                                    errors={errors.importFile}
                                    value={data.importFile}
                                    onChange={(file) =>
                                        setData("importFile", file)
                                    }
                                />
                            </div>
                            <div>
                                <MultiSelectInput
                                    items={groups}
                                    selected={data.groups}
                                    setSelected={(e) => setData("groups", e)}
                                    multiple={true}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className={"btn-secondary"}
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Import
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

Import.layout = (page) => (
    <Authenticated title={"Import Student"} children={page} />
);

export default Import;
